const snippets = {
  Snippets: "Snippets",
  // Picker dropdown
  AddASnippet: "Add a snippet to your message:",
  ManageSnippets: "Manage snippets",
  CreateSnippet: "Create snippet",
  YouHaveNoSnippets: "You have no snippets",
  YouHaveNoPinnedSnippets: "No pinned snippets",

  // Library modal
  SnippetLibrary: "Snippet library",
  CreateNewSnippet: "Create new snippet",
  ViewSnippetContent: "Hover over a snippet to view its content",
  EmptySnippetPreview: "Hover over a snippet to preview it here.",
  Preview: "Preview:",

  // Snippet editor form
  NewSnippet: "New snippet",
  EditSnippet: "Edit snippet",
  SnippetTitle: "Snippet title",
  SaveSnippet: "Save snippet",
  Cancel: "Cancel",
  SnippetSaved: "Snippet saved",
  TitleRequired: "Cannot be blank or have opening spaces",

  // Append/replace confirm modal
  AddSnippetTitle: "Add snippet",
  AddSnippetToExisting:
    "This recommendation already includes a message. Do you want to replace with the selected snippet or add to it?",
  AddSnippetToExistingInline: "Add to your current message?",
  Replace: "Replace",
  AddToCurrent: "Add",
  AttachToCurrent: "Attach",

  // Pin / unpin (per-item actions)
  PinSnippet: "Pin to top",
  UnpinSnippet: "Unpin",

  // Favorites filter toggle (list view)
  ShowFavoritesOnly: "Show pinned only",
  ShowAllSnippets: "Show all snippets",

  // Delete
  DeleteSnippetWithName: "Delete '{{snippetName}}'?",
  Delete: "Delete",
  DeleteSnippetSuccessfully: "Snippet has been deleted successfully",
  SnippetDeletedDefaultRestored: "Snippet deleted. Default snippet restored.",
  CannotDeleteDefaultSnippet: "Default snippets cannot be deleted",

  // Limits
  MaxSnippetsAllowed:
    "You may only have 30 snippets at once. Delete a snippet if you wish to create a new one.",
  MaxPinnedAllowed: "You may only pin 5 snippets",

  // Errors
  GenericError: "Something went wrong. Please try again.",
} as const;

export { snippets };
